import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class TransactionType extends Resource {
    public override type = 'transactionTypes';

    @prop()
    @required()
    public code!: string;

    @prop()
    @required()
    public name!: string;

    @prop()
    public active: boolean = true;
    
    @prop()
    public thirdPartyType!: string;

    @prop()
    public enableManualCode: boolean = false;
    
    @prop()
    public enableManualCreation: boolean = false;

    @prop()
    public enableTransactionSerie: boolean = false;

    @prop()
    public enableCase: boolean = false;

    @prop()
    public enablePrice: boolean = false;

    @prop()
    public enableDiscount: boolean = false;

    @prop()
    public enableTax: boolean = false;

    @prop()
    public enableGroup: boolean = false;

    @prop()
    public enableImportJobs: boolean = false;

    @prop()
    public enableImportExcel: boolean = false;

    @prop()
    public enableRate: boolean = false;
   

    @prop()
    public enableGeneralDescription: boolean = false;

    @prop()
    public enableEstimatedMaterialDays: boolean = false;

    @prop()
    public enableEstimatedWorkHours: boolean = false;
    
    @prop()
    public document_type!: string;

    @prop()
    public enablePhotos: boolean = false;
    
    @prop()
    public enableFiles: boolean = false;

    @prop()
    public enableTemplates: boolean = false;

    @prop()
    public enableCaseServiceNotificationNumber: boolean = false;

    @prop()
    public enablePaymentConditionNotes: boolean = false;

    @prop()
    public enableValidityDocNotes: boolean = false;
}